import React from "react";
import Container from "@material-ui/core/Container/Container";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import { styles } from "./CenteredContainer.styles";

interface ICenteredContainerProps extends WithStyles<typeof styles> {
    children: any;
}

const CenteredContainerPure: React.FunctionComponent<ICenteredContainerProps> = ({classes, children}) => {
    return <Container className={classes.root} maxWidth="lg">
        {children}
    </Container>;
};

export const CenteredContainer = withStyles(styles)(CenteredContainerPure);